import React, {useState} from 'react';
import {Button, Card, CardBody, Col, Container, Input, Row} from "reactstrap";
import infoIcon from "../../assets/img/icons/user/info-icon.png";
import {useHistory} from "react-router-dom";

const Invitation = () => {
    const [email, setEmail] = useState("")


   

    const history = useHistory();

const inviteUser=()=>{
}


    const visitDashboard = () => {
        history.push("/easy-flow/dashboard");
    }
    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <Card className="br-60 mt--150 step1-card">
                        <CardBody className="startCard pt-3">
                            <h1 className="font-weight-bold text-center">Invite Your Candidates!</h1>
                            <Row>
                                <Col sm={12} lg={6} xs={12}>
                                    <div className="mt-5">
                                        <p className="fs-14 ml-2 font-weight-bolder mb-2 text-muted">Single Email
                                            Invite</p>
                                            <Input type="email" placeholder="Type Email Address Here" defaultValue={email} onChange={(e) => setEmail(e.target.value)} className="copy-link-bg" />
                                    </div>
                                    <Row className="mt-5">
                                        <Col lg={6} sm={12} xs={12}>
                                            <Button onClick={inviteUser} className="previous-button text-white w-100"
                                                color="">Invite</Button>
                                        </Col>
                                        <Col lg={6} sm={12}>
                                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                                color="">Bulk Invite</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm={12} lg={6} xs={12}>
                                    <div className="mt-5">
                                        <p className="fs-12 ml-2 font-weight-bolder mb-2">Game URL has been
                                            activated</p>
                                        <div className="d-flex copy-link-bg align-items-center justify-content-between">
                                            <span>www.google.com</span>
                                            <Button className="nextButton text-white">Copy</Button>
                                        </div>
                                    </div>
                                    <Button className="previous-button text-white w-100 mt-5"
                                        color="" onClick={visitDashboard}>Visit Dashboard</Button>
                                    <div className="d-flex mt-3">
                                        <div>
                                            <img src={infoIcon} role="button" />
                                        </div>
                                        <div className="ml-1">
                                            <p className="details mt-1">Lorem ipsum dolor sit amet
                                                consectetur.</p>
                                            <p className="details">
                                                Pharetra pellentesque mi leo id
                                                est ornare. Libero nunc gravida at mattis. Facilisi
                                                consectetur
                                                et
                                                ultricies augue scelerisque gravida scelerisque consequat
                                                pellentesque.
                                            </p>
                                            <p className="details">
                                                Tincidunt nullam auctor iaculis commodo vel lacus urna ut.
                                                Scelerisque
                                                duis nunc consectetur cras sed ultricies vestibulum. Nec
                                                molestie tortor
                                                placerat tempor.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Invitation;